import React from 'react';
import { borderRadius, colors, spacing, typography, typographyFlat } from '../../styles/tokens';
import { formatInstant } from '../../utils/datetime';

type ReportGeneratedHeaderProps = {
  generatedAt: string | null | undefined;
  onRefresh: () => void;
  refreshing?: boolean;
};

/** Shared report status row: zoned generated time plus a reload control. */
export const ReportGeneratedHeader: React.FC<ReportGeneratedHeaderProps> = ({
  generatedAt,
  onRefresh,
  refreshing = false,
}) => {
  return (
    <div style={styles.row} role="region" aria-label="Report status">
      <span style={styles.generated}>Generated {formatInstant(generatedAt, '-')}</span>
      <button
        type="button"
        onClick={onRefresh}
        disabled={refreshing}
        style={{
          ...styles.refresh,
          cursor: refreshing ? 'not-allowed' : 'pointer',
          opacity: refreshing ? 0.7 : 1,
        }}
      >
        Refresh
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.md,
    flexWrap: 'wrap',
  },
  generated: {
    color: colors.textSecondary,
    fontSize: typography.small.fontSize,
  },
  refresh: {
    border: `1px solid ${colors.border}`,
    borderRadius: borderRadius.sm,
    backgroundColor: colors.surface,
    color: colors.text,
    padding: `${spacing.sm} ${spacing.md}`,
    fontSize: typography.body.fontSize,
    fontWeight: typographyFlat.fontWeight.semibold,
  },
};
